import type { Permission } from "@/api"
import { CONSTANT } from "@/constant"

export function isCenter(permissions: Permission[]) {
  return permissions
    .map(({ basename }) => basename)
    .includes(CONSTANT.ENUM.PERMISSION.CENTER)
}

export function isVendor(permissions: Permission[]) {
  return (
    isVendorAdmin(permissions) ||
    isVendorSales(permissions) ||
    isVendorSecurity(permissions)
  )
}

export function isVendorAdmin(permissions: Permission[]) {
  return permissions
    .map(({ basename }) => basename)
    .includes(CONSTANT.ENUM.PERMISSION.VENDOR_ADMIN)
}

export function isVendorSales(permissions: Permission[]) {
  return permissions
    .map(({ basename }) => basename)
    .includes(CONSTANT.ENUM.PERMISSION.VENDOR_SALES)
}

export function isVendorSecurity(permissions: Permission[]) {
  return permissions
    .map(({ basename }) => basename)
    .includes(CONSTANT.ENUM.PERMISSION.VENDOR_SECURITY)
}
